<template>
  <div class="page-container">
    <div class="licences">
      <div v-for="(item, index) in licences" :key="'licence' + index" class="licence-item">
        <div class="title">{{ item.title }}</div>
        <van-icon v-if="item.state == 0" class="add-btn" name="plus" @click="openAdd(item.id, item.title)">添加</van-icon>
        <div v-else class="state-info">已添加</div>
      </div>
    </div>
    <!-- 加载中遮罩层 -->
    <van-overlay :show="showLoading">
      <van-loading size="24px" class="loading-icon" type="spinner" color="#1989fa" />
    </van-overlay>
    <!-- 成功弹窗 -->
    <van-popup v-model="showSuccessDialog" :close-on-click-overlay="false" round>
      <div class="success-container">
        <img class="icon" src="@/assets/images/licences/icon_info.png" alt="" />
        <div class="text">经查询，您拥有{{ typeText }}<br />已为您添加</div>
        <div class="btn" @click="closeSuccessDialog">知道了</div>
      </div>
    </van-popup>
    <!-- 失败弹窗 -->
    <van-popup v-model="showFailDialog" :close-on-click-overlay="false" round>
      <div class="fail-container">
        <img class="icon" src="@/assets/images/licences/icon_info.png" alt="" />
        <div class="text">暂未查询到您的电子证照，敬请谅解</div>
        <div class="btn" @click="showFailDialog = false">知道了</div>
      </div>
    </van-popup>
    <!-- 要求实名弹窗 -->
    <van-popup v-model="showAuthentication" round :close-on-click-overlay="false">
      <div class="authentication-container">
        <div class="title">证照数据保护</div>
        <div class="text">您已开启证照数据保护，<br />此操作需要进行人脸识别~</div>
        <div class="text">此功能可在<br />“APP设置—证照数据保护”中关闭。</div>
        <div class="btns">
          <div class="btn default" @click="refuseAuthentication">稍后再说</div>
          <div class="btn primary" @click="openAuthentication">人脸识别</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
const SFApi = window.SFApi
const isInClient = SFApi.isInClient()
import * as tokenUtils from '@/utils/TokenUtils'
import { Toast } from 'vant'
import { getAddList, addItem, getAuthenticationSwitch, getCertificateDetail, licenseOauth, refreshOauth } from '@/service/system/licence.js'
export default {
  data() {
    return {
      showLoading: false,
      licences: [],
      switchChecked: null,
      showAuthentication: false,
      showSuccessDialog: false,
      showFailDialog: false,
      typeText: '',
      clientId: process.env.VUE_APP_MODE == 'production' ? 'ae3c25a0329ae4c5096050635f68045b' : '908a26e65bc3a2547ea8ac3dc916c6fd',
      clientSecret: process.env.VUE_APP_MODE == 'production' ? '6e46e31855c42507265702c35e3a04b0' : '7134e12aae796f0a97e9ee07e5a63229',
      appId: process.env.VUE_APP_MODE == 'production' ? '60502' : '60276',
      redirectUrl: location.href
    }
  },
  mounted() {
    const code = this.$route.query.code
    if (code) {
      licenseOauth(code, this.appId, this.clientId, this.redirectUrl)
        .then((res) => {
          const { data } = res
          tokenUtils.setAppToken(data.token)
          tokenUtils.setRefreshToken(data.refreshToken)
        })
        .catch((err) => {
          console.log(err)
        })
      this.checkLogin(this.openAuthenticationSwitch)
    } else {
      if (!tokenUtils.getAppToken()) {
        const params = {
          clientId: this.clientId,
          clientSecret: this.clientSecret,
          appid: this.appId,
          redirectUrl: this.redirectUrl // 跳转路由
        }
        SFApi.user.getOauthCode(params)
      } else {
        this.checkLogin(this.openAuthenticationSwitch)
      }
    }
  },
  methods: {
    checkLogin(doIt) {
      const that = this
      if (!tokenUtils.getToken()) {
        if (isInClient) {
          SFApi.user.login(function (code) {
            if (code == -1 || code == 1) {
              const token = SFApi.user.getToken()
              tokenUtils.setToken(token)
              if (doIt) {
                that.$nextTick(() => {
                  doIt()
                })
              }
            } else {
              Toast.fail('尚未登录')
            }
          })
        }
      } else {
        if (doIt) {
          doIt()
        }
      }
    },
    // 刷新token
    async refreshToken(cb) {
      try {
        const res = await refreshOauth(this.clientId, tokenUtils.getRefreshToken())
        tokenUtils.setRefreshToken(res.refreshToken)
        tokenUtils.setAppToken(res.token)
        if (cb) {
          cb()
        }
      } catch (err) {
        console.log(err)
      }
    },
    openAuthenticationSwitch() {
      const that = this
      this.showLoading = true
      const auth = tokenUtils.getAuthSwitch()
      const prevAuthSwitchAt = localStorage.getItem('prevAuthSwitchAt') ? Number(localStorage.getItem('prevAuthSwitchAt')) : 0
      const currAt = new Date().getTime()
      that.switchChecked = auth == 'true'
      if (that.switchChecked && currAt - prevAuthSwitchAt < 3600 * 1000) {
        that.loadingLicences()
        return
      }
      getAuthenticationSwitch()
        .then((data) => {
          that.switchChecked = data == 1
          tokenUtils.setAuthSwitch(that.switchChecked)
          if (that.switchChecked && currAt - prevAuthSwitchAt > 3600 * 1000) {
            that.showLoading = false
            that.showAuthentication = true
          } else {
            that.loadingLicences()
          }
        })
        .catch((err) => {
          that.showLoading = false
          Toast.fail(err)
        })
    },
    refuseAuthentication() {
      this.showAuthentication = false
      this.$router.back()
    },
    openAuthentication() {
      const that = this
      SFApi.user.authentication((res) => {
        if (res == 1) {
          SFApi.user.faceRecognition((code) => {
            if (code == 1) {
              that.showAuthentication = false
              localStorage.setItem('prevAuthSwitchAt', new Date().getTime())
              that.$nextTick(() => {
                that.loadingLicences()
              })
            }
          })
        } else {
          Toast.fail('尚未实名')
          that.$router.back()
        }
      })
    },
    async loadingLicences() {
      this.showLoading = true
      try {
        const data = await getAddList()
        this.licences = data
      } catch (err) {
        Toast.fail(err)
      } finally {
        this.showLoading = false
      }
    },
    async openAdd(id, title) {
      this.showLoading = true
      this.typeText = title
      try {
        await getCertificateDetail(Number(id))
        await addItem(id)
        this.showLoading = false
        this.showSuccessDialog = true
      } catch (err) {
        if (err.code == 60301) {
          this.refreshToken(() => {
            this.openAdd(id, title)
          })
        } else {
          this.showLoading = false
          this.showFailDialog = true
        }
      }
    },
    closeSuccessDialog() {
      this.showSuccessDialog = false
      this.$router.back()
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-container {
  width 100%
  height 100%
  background-color #F7F9F9
  overflow hidden auto
  font-family PingFangSC-Regular, PingFang SC
  font-weight 400
  div::-webkit-scrollbar {
    width 0
  }
  .loading-icon {
    position absolute
    top 50%
    left 50%
    transform  translate(-50%, -50%)
  }
  .licences {
    background-color #fff
    padding 0 30px
    .licence-item {
      width 100%
      height 100px
      display flex
      align-items center
      justify-content space-between
      .title {
        flex 1
        font-size 30px
        color #333333
        line-height 42px
      }
      .add-btn, .state-info {
        margin-left 20px
        font-size 24px
        line-height 42px
        width 120px
        text-align center
      }
      .add-btn {
        background rgba(16,112,255,0.15)
        border-radius 21px
        border 1px solid #1070FF
        color #1070FF
        padding 0 18px
      }
      .state-info {
        color #B3B3B3
      }
    }
    .licence-item+.licence-item {
      border-top 1px solid #ECECEC
    }
  }
  .success-container, .fail-container {
    width 660px
    padding 50px
    text-align center
    .icon {
      width 80px
      height auto
    }
    .text {
      margin-top 26px
      font-size 34px
      font-weight 500
      color #1A1A1A
      line-height 48px
    }
    .btn {
      margin 33px auto 0
      background #2F6CF5
      border-radius 45px
      font-size 32px
      font-weight 500
      color #FFFFFF
      line-height 70px
      padding 0 60px
      width fit-content
    }
  }
  .authentication-container {
    width 660px
    background #FFFFFF
    border-radius 10px
    padding 52px 70px
    .title {
      line-height 48px
      font-size 34px
      font-weight 500
      color #333333
      text-align center
    }
    .text {
      text-align center
      margin-top 44px
      font-size 30px
      color #999999
      line-height 42px
    }
    .btns {
      margin-top 52px
      display flex
      justify-content space-between
      .btn {
        width 226px
        line-height 68px
        border-radius 34px
        font-size 32px
        font-weight 500
        text-align center
      }
      .default {
        border 2px solid #2D8DFF
        color #2D8DFF
      }
      .primary {
        background-color #2D8DFF
        color #fff
      }
    }
  }
}
</style>
